/** 积分池管理 */

// 积分池列表-查询积分池列表
export const INTEGRAL_POOL_LIST = '/cmvip/integralPool/queryIntegralPool';
// 积分池列表-查询单条积分池列表数据
export const INTEGRAL_POOL_DETAIL = '/cmvip/integralPool/queryIntegralOne';
// 积分池列表-新增积分池账户
export const ADD_INTEGRAL_ACCOUNT = '/cmvip/integralPool/saveIntegralAccount';
// 积分池列表-增加积分
export const ADD_INTEGRAL = '/cmvip/integralPool/saveIntegral';
// 积分池列表-延期积分
export const DELAY_INTEGRAL = '/cmvip/integralPool/saveDelayIntegral';

// 积分池预警-查询积分池预警列表
export const INTEGRAL_WARNING_LIST = '/cmvip/integralPool/queryWarnIntegral';
// 积分池预警-查询单条预警积分
export const INTEGRAL_WARNING_DETAIL = '/cmvip/integralPool/queryWarnIntegralOne';
// 积分池预警-设置预警积分
export const ADD_INTEGRAL_WARNING = '/cmvip/integralPool/saveWarnIntegral';
// 积分池预警-设置预警邮箱
export const ADD_WARNING_EMAIL = '/cmvip/integralPool/saveWarnMail';
// 积分池预警-删除邮箱
export const DELETE_WARNING_EMAIL = '/cmvip/integralPool/deleteWarnMail';

// 积分池流水-查询审核通过列表
export const INTEGRAL_VERIFY_PASS = '/cmvip/integralPool/queryVerifyDetail';
// 积分池流水
export const GET_POINT_ACCOUNT_RECORD = '/cmvip/integralPool/getPointAccountRecord';

// 积分池审核-查询积分池审核列表
export const INTEGRAL_VERIFY_LIST = '/cmvip/integralPool/queryVerify';
// 积分池审核-设置积分池审核
export const ADD_INTEGRAL_VERIFY = '/cmvip/integralPool/saveVerify';
// 积分池审核-查询单条审核记录
export const INTEGRAL_VERIFY_DETAIL = '/cmvip/integralPool/queryVerifyOne';
// 积分池审核-基础数据
export const INTEGRAL_BASIC_DATA = '/cmvip/integralPool/queryVerifyOperate';
// 作废积分池
export const ABOLISH_INTEGRAL_POOL = '/cmvip/integralPool/abolishIntegralPool';
// 3.2积分池-扣减积分接口
export const REDUCE_INTEGRAL = '/cmvip/integralPool/reduceIntegral';

// 积分采购管理列表
export const INTEGRAL_PURCHASE_LIST = '/cmvip/integralPool/queryIntegralPoolApplyList';
// 新增积采购账户
export const ADD_PURCHASE_ACCOUNT = '/cmvip/integralPool/saveApplyAndSubmitMip';
